import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./awardtracker.css";

const awardData = [
  {
    Area: "Volunteer",
    DURATION: "HOUR",
    "Bronze Cert.\n NO month": 30,
    "Silver Cert.\n NO month": 60,
    "Gold Cert.\n 6 month": 90,
    "Bronze Medal\n 7 month": 100,
    "Silver Medal\n 12 month": 200,
    "Gold Medal\n 24 month": 400,
  },
  {
    Area: "Personal Development",
    DURATION: "HOUR",
    "Bronze Cert.\n NO month": 15,
    "Silver Cert.\n NO month": 30,
    "Gold Cert.\n 6 month": 45,
    "Bronze Medal\n 7 month": 50,
    "Silver Medal\n 12 month": 100,
    "Gold Medal\n 24 month": 200,
  },
  {
    Area: "Physics Fitness",
    DURATION: "HOUR",
    "Bronze Cert.\n NO month": 15,
    "Silver Cert.\n NO month": 30,
    "Gold Cert.\n 6 month": 45,
    "Bronze Medal\n 7 month": 50,
    "Silver Medal\n 12 month": 100,
    "Gold Medal\n 24 month": 200,
  },
  {
    Area: "Exploration",
    DURATION: "DAY",
    "Bronze Cert.\n NO month": 1,
    "Silver Cert.\n NO month": 2,
    "Gold Cert.\n 6 month": 3,
    "Bronze Medal\n 7 month": "2D + 1N",
    "Silver Medal\n 12 month": "3D + 2N",
    "Gold Medal\n 24 month": "5D + 4N",
  },
];

const AwardTracker = () => {
  return (
<div className="requirements-container">
			{/* Main Requirements Table */}
			<table className="requirements-table">
				<thead>
					<tr>
						<th>Area</th>
						<th>DURATION</th>
						<th>
							Bronze Cert.
							<br />
							NO month
						</th>
						<th>
							Silver Cert.
							<br />
							NO month
						</th>
						<th>
							Gold Cert.
							<br />6 month
						</th>
						<th>
							Bronze Medal
							<br />7 month
						</th>
						<th>
							Silver Medal
							<br />
							12 month
						</th>
						<th>
							Gold Medal
							<br />
							24
						</th>
					</tr>
				</thead>
				<tbody>
					<tr className="volunteer-row">
						<td>Volunteer</td>
						<td>HOUR</td>
						<td>30</td>
						<td>60</td>
						<td>90</td>
						<td>100</td>
						<td>200</td>
						<td>400</td>
					</tr>
					<tr className="personal-dev-row">
						<td>Personal Development</td>
						<td>HOUR</td>
						<td>15</td>
						<td>30</td>
						<td>45</td>
						<td>50</td>
						<td>100</td>
						<td>200</td>
					</tr>
					<tr className="fitness-row">
						<td>Physics Fitness</td>
						<td>HOUR</td>
						<td>15</td>
						<td>30</td>
						<td>45</td>
						<td>50</td>
						<td>100</td>
						<td>200</td>
					</tr>
					<tr className="exploration-row">
						<td>Exploration</td>
						<td>DAY</td>
						<td>1</td>
						<td>2</td>
						<td>3</td>
						<td>2D + 1N</td>
						<td>3D + 2N</td>
						<td>5D + 4N</td>
					</tr>
				</tbody>
			</table>

			{/* Requirements Section */}
			<div className="requirements-section">
				<h3>HOUR + MONTH REQUIREMENTS</h3>
				<ol>
					<li>
						<strong>Spread out your hours:</strong> The purpose of the program is to set long-term goals. Your activities should be spread out over
						the months that you are working towards your goals. The month requirement refers to the months that you are actively working towards your
						goals in each program area.
					</li>
					<li>
						<strong>
							You must complete at least one hour of activity in a month for that month to count. Months of activity do not need to be consecutive.
						</strong>
					</li>
					<li>
						<strong>Months in a program area only count once.</strong>
						<br />
						Example: If you play ice hockey and soccer and you have activity for each in January 2020 you can only count January 2020 one time towards
						your Physical Fitness month requirement.
					</li>
					<li>
						<strong>No more than eight hours of activity per day.</strong>
						<br />
						Example: If your Voluntary Public Service activities include volunteering as a camp counselor, you may only count eight hours per day even
						if you are spending the night at the camp.
					</li>
				</ol>
			</div>

			{/* Area & Purpose Table */}
			<table className="purpose-table">
				<thead>
					<tr>
						<th>AREA & PURPOSE AND MORE</th>
						<th>
							NOT TO COUNT (See complete descriptions in the Program Book)
							<br />
							Do your planned goals and activities follow the guidelines?
						</th>
					</tr>
				</thead>
				<tbody>
					<tr className="volunteer-section">
						<td>
							<h4>Volunteer</h4>
							<p>Sharing Time and Talents for the Benefit of Others</p>
							<p>
								Voluntary Public Service is meant to provide opportunities for you to dive into your community with hands-on volunteer experiences.
								This requires sensitivity, assessment of needs, and determination.
							</p>
							<p>Voluntary Public Service can have a maximum of 4 goals</p>
						</td>
						<td>
							<ul>
								<li>No School/Class Credit / • No Compensation</li>
								<li>No Spreading of Faith or Proselytizing</li>
								<li>No Private/For-Profit Businesses</li>
								<li>No Entrance/Membership Fees</li>
								<li>Service Be Open to the Public / • Must be Non-Partisan</li>
								<li>Indirect Service Cannot Exceed 25% of Activity</li>
							</ul>
						</td>
					</tr>
					<tr className="personal-dev-section">
						<td>
							<h4>Personal Development</h4>
							<p>Pursuing a new interest or advancing in an ongoing interest</p>
							<p>Personal Development is a chance for you to explore a new interest or work to improve your skills in an existing hobby.</p>
							<p>Personal Development can have a maximum of 2 goals</p>
						</td>
						<td>
							<ul>
								<li>Measurable & Challenging</li>
								<li>No School/Class Credit</li>
								<li>Part-Time Jobs are allowed</li>
								<li>Many clubs, organizations, or hobbies may count here</li>
							</ul>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
  );
};

export default AwardTracker;
